import script from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangeSelect.vue?vue&type=style&index=0&id=83752372&lang=scss"

const __exports__ = script;

export default __exports__